import { SystemError } from "../error";
import { Change, Version, } from "../value-objects";
import { Entity } from "./entity";
export class BaseEntity {
    id;
    v;
    constructor(value) {
        this.id = value.id;
        this.v = value;
    }
    toValues() {
        return Entity.toJson(this);
    }
    get version() {
        return this.v.version;
    }
    setCreated(updater) {
        this.v.change = Change.create(updater);
        this.v.version = Version.initial();
    }
    setUpdated(updater) {
        if (!this.v.change) {
            throw new SystemError.Unexpected("change is undefined");
        }
        this.v.change = this.v.change.update(updater);
        this.v.version = this.v.version.increment();
    }
}
//# sourceMappingURL=base-entity.js.map